<template>
  <div class="main-view-padding has-header">
      <div class="header main" v-header-position-lock>
          <div class="align-left">
          </div>
          <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
          </div>
          <div class="align-right">
          </div>
      </div>
      <div class="scrollbar-container content">
        <b-container fluid>
          <div class="full">
            <div class="mainheader">
              {{ $t('employee.collective.collectiveAgreements') }}
            </div>
          </div>

          <div v-if="loading">
            <i class="fas fa-circle-notch fa-spin"></i> {{ ' ' + $t('employee.collective.pleaseWait') }}<br />
            {{ $t('employee.collective.loadingCollectiveAgreements') }}<br />
            <div style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 25px"></div>
          </div>
          <div v-if="!loading" class ="tablecontainer scrollbar-container">
            <!-- LIST OF COLLECTIVE AGREEMENTS -->
            <div class="collective-agreement-list">
              <div class="collective-agreement list-header">
                {{ $t('employee.collective.collectiveAgreements') }}
              </div>
              <div class="collective-agreement-list-overflow" style="overflow: auto">
                <div v-for="collectiveAgreementCountry,index in Object.entries(contractCollectiveAgreements).filter(c => billingAddress ? billingAddress.countryId == c[0] : true).sort((a,b)=>Object.values(a)[0].countryId - Object.values(b)[0].countryId)" v-bind:key="'countryIndex_' + index" class="collective-agreement-country-container">
                    <div class="collective-agreement-country-title" >
                      {{ $t(`enum.country.${Object.values(collectiveAgreementCountry[1])[0].countryId}`) }}
                    </div>
                    <div v-for="collectiveAgreement in Object.values(collectiveAgreementCountry[1])" class="collective-agreement" v-on:click="selectedCollectiveAgreement=collectiveAgreement; setCurrentValidFromDate(); nameFilter=''; updateFilter();"
                        v-bind:class="{'selected': selectedCollectiveAgreement.id===collectiveAgreement.id}" v-bind:key="collectiveAgreement.id">
                        {{ collectiveAgreement.name }}
                    </div>
                </div>
              </div>
            </div>
            <!-- ACTUAL SETTINGS -->
            <!-- <div class="collective-agreement-wagetable-date-list">
              <div class="collective-agreement-wagetable-date list-header">
                Gültig ab
              </div>
              <div v-for="validFromDate in getValidFromDates()" class="collective-agreement-wagetable-date" v-on:click="selectedValidFromDate=validFromDate"
                    v-bind:class="{'selected': selectedValidFromDate===validFromDate}" v-bind:key="validFromDate">
                {{ printValidFromDate(validFromDate) }}
              </div>
            </div> -->
            <div class="collective-agreement-wagetable-container">
              <div class="collective-agreement-wagetable-content">
                <div style="display:flex; justify-content:space-between; margin-bottom: 16px;">
                    <div>
                      <select class="modern-select-header" v-model="selectedValidFromDate">
                        <option v-for="validFromDate in getValidFromDates()" :key="validFromDate" :value="validFromDate">
                            {{ $t('employee.collective.validFrom') + ' '}} {{ printValidFromDate(validFromDate) }}
                        </option>
                      </select>
                    </div>
                    <div>
                      <input class="searchInput" v-model="nameFilter" :placeholder="$t('employee.collective.filterTariffGroups')" style="margin-left: 96px;"/>
                    </div>

                  </div>
                <table class="styled-table" v-show="selectedValidFromDate != null" style="width: 100%">
                  <tr>
                      <th>{{ $t('employee.collective.tariffGroup') }}</th>
                      <th>{{ $t('employee.collective.amount') }}</th>
                      <th>{{ $t('employee.collective.paymentType') }}</th>
                      <th>{{ $t('employee.collective.wageType') }}</th>
                      <th>
                          {{ $t('employee.collective.states') }}
                          <i class="fas fa-eye" @click="openFilterStatesPopup($event)"></i>
                      </th>
                  </tr>
                  <tr v-for="wg in getNormalizedWageGroupsByValidFromDate(selectedValidFromDate)" :key="wg.id + '_' + wg.amountId + '_' + wg.header + '_' + wg.empty">
                      <td v-if="wg.header && wg.empty" colspan="5">
                          <strong>{{ $t('employee.collective.warning') }} </strong>
                          {{ $t('employee.collective.noWageFor') }}
                          {{ wg.name }}
                          ({{
                              wg.stateIds.map(
                                  stateId => countryStateEnumMapByCountry[selectedCollectiveAgreement.countryId].find(
                                      e => e.stateId == stateId).valueGER).join(', ')
                          }})
                          {{ $t('employee.collective.notStored') }}
                      </td>
                      <td v-else-if="wg.header && !wg.empty" colspan="5"><div style="height: 20px"></div></td>
                    <template v-else>
                      <td>{{ wg.name }}</td>
                      <td>{{ wg.amount ? (wg.amount / 100.0).toFixed(2) : "-" }}</td>
                      <td>{{ wg.paymentType ? $t(`enum.paymentType.${wg.paymentType}`) : "-" }}</td>
                      <td>{{ wg.wageType ? $t(`enum.wageType.${wg.wageType}`) : "-" }}</td>
                      <td>{{ wg.stateIds ? wg.stateIds.length == countryStateEnumMapByCountry[selectedCollectiveAgreement.countryId].length ?
                          $t('employee.collective.allStates') : wg.stateIds.map(stateId => countryStateEnumMapByCountry[selectedCollectiveAgreement.countryId].find(e => e.stateId == stateId).valueGER).join(', ') : "-" }}</td>
                    </template>
                  </tr>
                </table>

                <div v-show="selectedValidFromDate == null">
                  <div style="width: 100%; text-align: center; color: #222222">
                      {{ $t('employee.collective.noTariffGroupsForCollective') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-container>
    </div>


  </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
import button from '../uicomponents/button.vue';
export default {
 components: { button },
  name: 'collectiveAgreements',
  data () {
    return {
      loading: true,
      selectedCollectiveAgreement: null,
      selectedValidFromDate: null,

      contractCollectiveAgreements: {},
      contractWageGroups: {},
      countryStateEnumMapByCountry: {},

      wageTypeArray: [],
      paymentTypeArray: [],

      billingAddress: null,
      stateFilter: [],
      nameFilter: '',
    }
  },
  created: function () {
    //console.log("CREATED");
  },
  mounted: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.companyId != undefined){
        this.refresh();
    }
  },
  computed: {
    ...mapGetters(['companyId', 'isSuperUser', 'countryEnumMap', 'countryStateEnumMap', 'storeMap', 'companySettings']),
    dateDisplay: function() {
      return this.$helpers.getMomentTZ().format('YYYY-MM-DD');
    },
    headerButtons() {
        let view = this;
        let state = {
          buttons: [
            {
              type: "block",
              icon: "fa-refresh",
              click: () => {
                this.refresh();
              },
              show: true,
              disabled: false,
              tooltip: view.$t('settings.wage.reloadData'),
              title: view.$t('settings.wage.reloadData')
            },
          ]
        };
        return state;
    },
  },
  watch: {
    companyId: function(val, oldVal) {
      this.refresh();
    },
    selectedCollectiveAgreement: function (newVal, oldVal) {
      // console.log("selectedCollectiveAgreement", newVal, oldVal);
    },
    nameFilter: function (newVal, oldVal) {
      // console.log("nameFilter", newVal, oldVal);
      this.updateFilter();
    },
  },
  // methods that implement data logic.
  methods: {
    refresh: function(force = false){
      let view = this;
      view.loading = true;
      view.stateFilter = [];
      view.nameFilter = '';
      view.billingAddress = null;

      let promises = [];
      promises.push(view.getContractCollectiveAgreements());
      promises.push(view.$helpers.GetStores());
      promises.push(view.$helpers.GetCompanySettings(force));

      Promise.all(promises)
      .then((responses) => {
        view.countryStateEnumMapByCountry = {};
        Object.values(view.countryStateEnumMap).forEach(c => {
          if (!view.countryStateEnumMapByCountry.hasOwnProperty(c.countryId)) {
            view.countryStateEnumMapByCountry[c.countryId] = [];
          }
          view.countryStateEnumMapByCountry[c.countryId].push(c);
        });
        // console.log("countryStateEnumMapByCountry", view.countryStateEnumMapByCountry);

        view.billingAddress = view.companySettings.data.length == 1 ? view.companySettings.data[0].billing_address : null;
        view.selectedCollectiveAgreement = Object.values(
          Object.entries(view.contractCollectiveAgreements)
            .filter(c => view.billingAddress ? view.billingAddress.countryId == c[0] : true)
            .sort((a,b)=>Object.values(a)[0].countryId - Object.values(b)[0].countryId)
            [0][1]
          )[0];

        view.setCurrentValidFromDate();

        view.loading = false;
      });
    },

    // helpers
    printValidFromDate(validFrom) {
      let date = new Date(validFrom);
      let year = new Intl.DateTimeFormat('de', { year: 'numeric' }).format(date);
      let month = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(date);
      let day = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(date);
      return `${day}.${month}.${year}`;
    },
    getNormalizedWageGroupsByValidFromDate(validFrom) {
      let view = this;
      let normalizedWageGroups = [];

      if (view.contractWageGroups[view.selectedCollectiveAgreement.id] == undefined) {
        return normalizedWageGroups;
      }

      let countryStateFilter = view.stateFilter.map(e => Object.values(view.countryStateEnumMap).find(c => c.id == e).stateId);

      view.contractWageGroups[view.selectedCollectiveAgreement.id]
        .sort((a,b) => a.stateIds[0] - b.stateIds[0])
        .filter(wg => wg.show && (view.stateFilter.length == 0 || wg.stateIds.some(e => !countryStateFilter.includes(e))))
        .forEach(wg => {
        let currentWageGroup = [];
        wg.wage_amounts.filter(wa => wa.validFrom === validFrom).forEach(wa => {
          let wageGroup = {};
          wageGroup.name = wg.name;
          wageGroup.id = wg.id;
          wageGroup.paymentType = wa.paymentType;
          wageGroup.wageType = wa.wageType;
          wageGroup.amount = wa.amount;
          wageGroup.amountId = wa.id;
          wageGroup.stateIds = wg.stateIds;
          currentWageGroup.push(wageGroup);
        });
        if (currentWageGroup.length == 0)
          currentWageGroup.push({name: wg.name, id: wg.id, stateIds: wg.stateIds, header: true, empty: true});
        //currentWageGroup.push({name: wg.name, id: wg.id, header: true, empty: false});
        normalizedWageGroups = normalizedWageGroups.concat(currentWageGroup);
      });
      console.log(normalizedWageGroups);
      return normalizedWageGroups;
    },
    getValidFromDates() {
      let view = this;
      let validFromDates = [];

      // console.log(view.selectedCollectiveAgreement);

      if (view.contractWageGroups[view.selectedCollectiveAgreement.id] == undefined) {
        return validFromDates;
      }

      // get all from dates
      view.contractWageGroups[view.selectedCollectiveAgreement.id].forEach(wg => {
        wg.wage_amounts.forEach(wa => {
          if (!(validFromDates.includes(wa.validFrom))) {
            validFromDates.push(wa.validFrom.toString());
          }
        });
      });
      validFromDates = validFromDates.sort((a,b) => {
        return new Date(b) - new Date(a);
      });
      return validFromDates;
    },
    setCurrentValidFromDate() {
      let view = this;
      let validFromDates = view.getValidFromDates();
      if (validFromDates.length > 0) {
        view.selectedValidFromDate = validFromDates[0];
      } else {
        view.selectedValidFromDate = null;
      }
    },
    openFilterStatesPopup($event) {
      let view = this;
      var target = $event.currentTarget;
      console.log(view.stateFilter);

      let stateFilterLocal = view.countryStateEnumMapByCountry[view.selectedCollectiveAgreement.countryId].map(e => {
        return {
          key: e.id, // use id instead of stateId to avoid confusion with different countries
          label: e.valueGER,
          toggled: !view.stateFilter.includes(e.id),
        };
      });
      // console.log(stateFilterLocal);

      this.$helpers.OpenPopup({
        elRelative: target,
        type: "list",
        componentState: {
          entries: stateFilterLocal,
        },
        remainAfterSelect: true,
        pointerDirection: 0,
        iconsLeft: true,
        selectCallback: function ($event, item, dropdown) {
          item.toggled = !item.toggled;
          if (view.stateFilter.includes(item.key)) {
            view.stateFilter = view.stateFilter.filter(e => e !== item.key);
          } else {
            view.stateFilter.push(item.key);
          }
        },
      });
    },
    updateFilter(){
      this.contractWageGroups[this.selectedCollectiveAgreement.id].forEach(wg => {
        if(this.nameFilter == ''){
          wg.show = true;
        }else{
          let filterParts = this.nameFilter.split(' ');
          let wgNameParts = wg.name.split(' ');
          let match = true;
          filterParts.forEach(fp => {
            if(!wgNameParts.some(wgnp => wgnp.toLowerCase().includes(fp.toLowerCase()))){
              match = false;
            }
          });
          if (match) {
            wg.show = true;
          }else{
            wg.show = false;
          }
        }
      });
    },


    // collective agreements
    getContractCollectiveAgreements() {
      let view = this;

      let url = '/api/sec/contract/collectiveAgreement';
      const params = {
        companyId: this.$store.state.companyId,
      };

      return this.axios({
        method: 'get',
        headers: { 'AUTHORIZATION': "Bearer "+this.$store.state.jwt },
        url: url,
        params
      }).then((response) => {
        view.contractCollectiveAgreements = {};
        view.contractWageGroups = {};
        response.data.forEach(r => {
          if (!view.contractCollectiveAgreements.hasOwnProperty(r.countryId)) {
            view.contractCollectiveAgreements[r.countryId] = {};
          }
          view.contractCollectiveAgreements[r.countryId][r.id] = r;
          r.wage_groups.forEach(wg => {
            wg.show = true;
          });
          view.contractWageGroups[r.id] = r.wage_groups;
        });
      }).catch((error) => {
        console.log(error);
          view.$helpers.error(
              view.$t('global.messages.error'),
              view.$t('employee.collective.collectiveLoadFailed')
          );
      });
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.main-view-padding {
  padding-left: 0px;
}

.page-header {
  font-size: 32px;
  text-align: left;
  color: #e51550;
  border-bottom:1px solid #ccc;
  font-weight:400;
  padding: 5px 5px 5px 20px;
}

.has-header > .scrollbar-container{
  position: initial;
  height: calc(100% - var(--header-height) - 20px) !important;
  top: var(--header-height);
  overflow-x: hidden;
}

.tablecontainer {
  margin-top: 48px;
  display: flex;
}

.list-header {
  font-weight:800;
  padding: 5px 5px 5px 20px;
  font-family: DistrictProBold;
  background-color: var(--contrast-4) !important;
  color: var(--bg);
}

.collective-agreement-list {
  height: 100%;
  width: 250px;
  text-align: left;
  font-family: DistrictProBook;
  font-size: 12px;
  border-right: solid 2px var(--contrast-7);
}
.collective-agreement-list > .collective-agreement,
.collective-agreement-list > .collective-agreement-list-overflow > .collective-agreement-country-container > .collective-agreement{
  min-height: 40px;
  width: 100%;
  padding-left: 16px;
  display: flex;
  align-items: center;
  background: var(--contrast-2);
}
.collective-agreement-list > .collective-agreement:not(.list-header):hover,
.collective-agreement-list > .collective-agreement-list-overflow > .collective-agreement-country-container > .collective-agreement:not(.list-header):hover,
.selected {
  color: var(--bg);
  background: var(--ml) !important;
  font-family: DistrictProBold;
  font-weight: 800;
}
.collective-agreement-list > .collective-agreement:not(.list-header):nth-child(odd),
.collective-agreement-list > .collective-agreement-list-overflow > .collective-agreement-country-container > .collective-agreement:not(.list-header):nth-child(odd){
  background: var(--contrast-1);
}
.collective-agreement-list-overflow {
  overflow: auto;
  height: calc(100% - 40px);
}
.collective-agreement-country-title {
  font-weight: bold;
  padding: 4px 16px 2px 16px;
  font-size: 12px;
  font-family: DistrictProBold;
  background-color: var(--contrast-8);
  color: var(--ml);
}
.collective-agreement-settings {
  height: 100%;
  width: 250px;
  text-align: left;
}
.collective-agreement-settings > .collective-agreement-setting {
  min-height: 40px;
  width: 100%;
  padding-left: 16px;
  display: flex;
  align-items: center;
  background: var(--contrast-2);
}
.collective-agreement-settings > .collective-agreement-setting:not(.list-header):hover,.selected {
  color: var(--bg);
  background: var(--ml) !important;
  font-family: DistrictProBold;
  font-weight: 800;
}
.collective-agreement-settings > .collective-agreement-setting:nth-child(even){
  background: var(--contrast-1);
}

.collective-agreement-wagetable-container {
  width: calc(100% - 500px);
  height: 100%;
  display: flex;
}
.collective-agreement-wagetable-content {
  width: 100%;
  overflow: auto;
  padding: 0px 24px;
}
.collective-agreement-wagetable-date-list {
  height: 100%;
  width: 250px;
  text-align: left;
  font-family: DistrictProBook;
  font-size: 12px;
  border-right: solid 2px var(--contrast-7);
}
.collective-agreement-wagetable-date-list > .collective-agreement-wagetable-date {
  min-height: 40px;
  width: 100%;
  padding-left: 16px;
  display: flex;
  align-items: center;
  background: var(--contrast-2);
}
.collective-agreement-wagetable-date-list > .collective-agreement-wagetable-date:not(.list-header):hover,.selected {
  color: var(--bg);
  background: var(--ml) !important;
  font-family: DistrictProBold;
  font-weight: 800;
}
.collective-agreement-wagetable-date-list > .collective-agreement-wagetable-date:nth-child(odd){
  background: var(--contrast-1);
}

.collective-agreement-content-container {
  height: 100%;
  width: 100%;
  overflow: auto;
}
.collective-agreement-content {
  height: 100%;
}


.btn-outline-success {
  color: var(--ml);
  border-color: var(--ml);
  margin-bottom: 2px;
  margin-right: 2px;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: var(--ml);
  border-color: var(--ml);
}
.btn-outline-success:focus,
.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(162, 16, 57, 0.5);
}

.searchInput{
    height: 23px;
    font-size: 12px;
    /* padding: 0px; */
    padding-left: 10px;
    width: 170px;
    background: white;
    box-shadow: inset 0 0 0 1px #cccccc;
}
.searchArea{
    border-radius: 30px;
    margin-left: 5px;
    /* margin-right: 10px; */
    width: 110px;
    text-align: center;
    height: 23px;
    /* margin-bottom: 15px; */
    line-height: 23px;
    /* margin-top: 8px; */
    display: inline-block;
    cursor: pointer;
}
.searchArea > .searchButton{
    border-radius: 30px;
    height: 23px;
    /* margin-right: 15px; */
    /* line-height: 15px; */
    font-size: 11px;
    font-weight: bold;
    font-family: DistrictProBook;
    cursor: pointer;
    color: #888;
    background-color: #e5e5e5;
    box-shadow: rgb(128 128 128) 0px 0px 0px 1px inset;
    cursor: pointer;
    text-shadow: #ffffff 1px 0 10px;
}
.searchArea > .searchButton:hover{
    background-color:#404040;
    font-weight:normal;
    color:#fff;
    cursor: pointer;
    box-shadow: rgb(200 200 200) 0px 0px 0px 1px inset;
}

</style>
